import { IContext } from "./types";

export const conversionIsDone = (ctx: IContext) => {
  return ctx.conversionStatus?.status === "Done";
};

export const conversionFailed = (ctx: IContext) => {
  return ctx.conversionStatus?.status === "Failed";
};
